/*
 * @Author: Christion.Young
 * @Date: 2023-10-18 10:28:11
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: CryptoJS加密解密工具
 */
import CryptoJS from "crypto-js";

/**
 * OAuth2 密码加密 - AES-CFB模式
 * @param {string} src - 原始密码明文
 * @param {string} keyWord - 加密密钥
 * @returns {string} 加密后的密文
 */
export function encryption(src, keyWord) {
  // 将密钥转换为UTF8编码的CryptoJS密钥对象
  const key = CryptoJS.enc.Utf8.parse(keyWord);

  // 使用AES算法加密
  var encrypted = CryptoJS.AES.encrypt(src, key, {
    iv: key, // 初始化向量（使用密钥作为IV）
    mode: CryptoJS.mode.CFB, // 加密模式：CFB（密码反馈模式）
    padding: CryptoJS.pad.NoPadding, // 填充方式：无填充
  });

  // 返回加密后的字符串
  return encrypted.toString();
}

/**
 * OAuth2 密码解密 - AES-CFB模式
 * @param {string} src - 加密后的密文
 * @param {string} keyWord - 解密密钥
 * @returns {string} 解密后的明文
 */
export function decryption(src, keyWord) {
  // 将密钥转换为UTF8编码的CryptoJS密钥对象
  const key = CryptoJS.enc.Utf8.parse(keyWord);

  // 使用AES算法解密
  var decryptd = CryptoJS.AES.decrypt(src, key, {
    iv: key, // 初始化向量（与加密时相同）
    mode: CryptoJS.mode.CFB, // 解密模式（与加密时相同）
    padding: CryptoJS.pad.NoPadding, // 填充方式（与加密时相同）
  });

  // 将解密结果转换为UTF8字符串
  return decryptd.toString(CryptoJS.enc.Utf8);
}

/**
 * AES 加密 - 原有CBC模式（保持兼容性）
 * @param {*} src  明文
 * @param {*} keyWord  密钥
 * @returns 密文
 */
export function aesEncrypt(src, keyWord = "zhongrunsafezrjs") {
  // 密钥
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  // 偏移量
  var iv = key;
  // 加密
  var encrypted = CryptoJS.AES.encrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return encrypted.toString();
}

/**
 *  解密
 * @param {*} result 密文
 * @param {*} keyWord 密钥
 * @returns 明文
 */
export function aesDecrypt(result, keyWord = "zhongrunsafezrjs") {
  // 密钥
  const key = CryptoJS.enc.Latin1.parse(keyWord);
  // 偏移量
  var iv = key;
  // 解密逻辑
  var decryptd = CryptoJS.AES.decrypt(result, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return decryptd.toString(CryptoJS.enc.Utf8);
}
